<template>
  <div style="">
    <div style="font-size: 18px;line-height: 1.8em;">
      {{ `${params.dis.toFixed(2)}km` }}
    </div>
      <el-button size="mini" @click="del">删除</el-button>
  </div>
</template>

<script>


export default {
  name: 'polylineTooltip',
  props: {
    params: Object
  },
  computed: {
    
  },
  data() {
    return {
      
    }
  },
  watch: {
   

  },
  mounted: function () {
   
  },
  methods: {
   del(){
    this.params.myPolyline.remove()
   }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-row {
  margin-bottom: 8px;
  line-height: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-radio {
  margin-right: 0px !important;
}

.right {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/main/PolylineTooltip.vue